import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const ContactUs = () => {
  const [openIndex, setOpenIndex] = useState(0);
  useEffect(() => {
      window.scrollTo(0, 0);
    }, []);

    const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return (
    <div>
      <div className="px-6 md:px-[4.5rem] pb-3 pt-[7rem] md:pt-[9rem] bg-[#DC143C] md:flex justify-between items-center gap-40">
        <div className="md:w-1/2">
          <h2 className="text-[#FFF] font-[Figtree] text-[0.75rem] md:text-[1rem] text-center md:text-left font-medium leading-[2.375rem] tracking-[0.26rem] uppercase">
            contact us
          </h2>
          <h2 className="md:w-[88%] text-[#FFF] font-[Figtree] text-[1.9375rem] md:text-[2.875rem] text-center md:text-left font-medium leading-[2.6875rem] md:leading-[3.6875rem] tracking-[-0.0775rem] md:tracking-[-0.115rem]">
            Let’s Stay Connected: Reach Out{" "}
            <span className="font-extrabold"> Anytime, Anywhere!</span>
          </h2>
          <div className="flex gap-[1.94rem] mt-[1.94rem]">
            <div className="bg-white w-[15.8125rem] py-6 px-[1.69rem] rounded-[1.125rem]">
              <h2 className="text-[#E11740] font-[Figtree] text-[1.125rem] font-extrabold leading-[1.4375rem] mb-[0.88rem]">
                Live Chat
              </h2>
              <h2 className="text-[#252525] font-[Figtree] text-[1rem] font-extrabold leading-[1.4375rem] mb-1">
                Need quick help?
              </h2>
              <h2 className="text-[rgba(37,37,37,0.82)] font-[Figtree] text-[1rem] font-normal leading-[1.4375rem]">
                Use our in-app Live Chat feature for instant support.
              </h2>
            </div>
            <div className="bg-white w-[15.8125rem] py-6 px-[1.69rem] rounded-[1.125rem]">
              <h2 className="text-[#E11740] font-[Figtree] text-[1.125rem] font-extrabold leading-[1.4375rem] mb-[0.88rem]">
                FAQs
              </h2>
              <h2 className="text-[#252525] font-[Figtree] text-[1rem] font-extrabold leading-[1.4375rem] mb-1">
                Need Help Fast?
              </h2>
              <h2 className="text-[rgba(37,37,37,0.82)] font-[Figtree] text-[1rem] font-normal leading-[1.4375rem]">
                Find instant answers to your questions.
              </h2>
            </div>
          </div>
        </div>
        <div className="md:w-1/2 flex justify-end mt-8 md:mt-0">
          <img
            src="/assets/ContactUsLeftBgImg.svg"
            alt="ContactUsLeftBgImg"
          />
        </div>
      </div>
      <div className="grid grid-cols-1 md:flex w-full">
        <div className="bg-[#D20B33] md:w-1/3 md:px-[7.5rem] md:py-[2.15rem] px-6 py-3">
          <h1 className="text-[#FFF] font-[Figtree] text-[0.625rem] font-medium leading-[1.29544rem] tracking-[0.1625rem] uppercase">
            Mobile Number
          </h1>
          <h1 className="text-[#FFF] font-[Figtree] text-[0.975rem] md:text-[1.56819rem] font-extrabold leading-[2.01138rem] tracking-[-0.06275rem]">
            +91-91099 10995
          </h1>
        </div>
        <div className="bg-[#C31135] md:w-1/3 md:px-[7.5rem] md:py-[2.15rem] px-6 py-3">
          <h1 className="text-[#FFF] font-[Figtree] text-[0.625rem] font-medium leading-[1.29544rem] tracking-[0.1625rem] uppercase">
            Email Us
          </h1>
          <h1 className="text-[#FFF] font-[Figtree] text-[0.975rem] md:text-[1.56819rem] font-extrabold leading-[2.01138rem] tracking-[-0.06275rem]">
            support@nimofx.com
          </h1>
        </div>
        <div className="bg-[#D20B33] md:w-1/3 md:px-[7.5rem] md:py-[1.06rem] px-6 py-3">
          <h1 className="text-[#FFF] font-[Figtree] text-[0.625rem] font-medium leading-[1.29544rem] tracking-[0.1625rem] uppercase">
            Headoffice
          </h1>
          <h1 className="text-[#FFF] font-[Figtree] text-[1rem]text-[0.875rem] md:text-[1rem] font-normal leading-[1.3875remrem] tracking-[-0.06275rem]">
            Paywize Forex Pvt Ltd M.R Complex, 7th Cross, 6th Main Rd, BTM 2nd
            Stage, Bengaluru-560076
          </h1>
        </div>
      </div>

      <div className="md:flex items-center px-6 md:px-[4.5rem] mt-16">
        <div className="md:w-[30%] min-[1700px]:w-[25%]">
          <h2 className="text-[#1D1D1D] text-[1.79031rem] md:text-[2.3125rem] text-center md:text-left font-normal leading-[2.12288rem] md:leading-[3.875rem] mb-5 md:mb-9">
            Frequently Asked{" "}
            <span className="text-[#DC143C] font-bold">Questions</span>
          </h2>
          <div className="flex justify-center md:justify-start">
            <Link to={"/faq"}>
            <button className="bg-[#DC143C] py-3 px-[1.375rem] rounded-lg text-white font-[Figtree] text-[0.75rem] md:text-[1.25rem] font-semibold leading-5 tracking-[-.06rem]">
              View more
            </button>
            </Link>
          </div>
        </div>
        <div className="md:w-[70%] min-[1700px]:w-[75%]">
          {/* Collapsible FAQ Items */}
          {[
            {
              question: "How do I apply for a Nimo Forex Card?",
              answer:
                "You can apply for a Nimo Forex Card through our mobile app or website. Simply sign up, load funds, and get started. Virtual cards are available instantly, and physical cards can be delivered to your doorstep.",
            },
            {
              question: "What currencies can I load on the card?",
              answer:
                "Nimo Forex Cards support all major international currencies, including USD, EUR, GBP, AUD, CAD, SGD, AED, and many more. Check the app for the full list.",
            },
            {
              question: "Can I lock in exchange rates while loading my card?",
              answer:
                "Yes! With Nimo Forex Cards, you can lock in real-time exchange rates while loading funds, protecting you from currency fluctuations.",
            },
            {
              question: "Where can I use my Nimo Forex Card?",
              answer:
                "You can use your card anywhere in the world where Visa/Mastercard is accepted, including ATMs, retail stores, and online platforms.",
            },
            {
              question: "Can I withdraw cash from ATMs with my Forex Card?",
              answer:
                "Yes! You can withdraw local currency from ATMs worldwide. Many ATMs are fee-free when you use your Nimo Forex Card.",
            },
            {
              question: "How can I contact support for assistance?",
              answer:
                "You can reach our customer support team 24/7 through the Nimo app, email, or hotline for any questions or issues.",
            },
          ].map((faq, index) => (
            <div
              key={index}
              className="border p-6 rounded-lg border-[#DEDEDE] text-left mt-[1.12rem] cursor-pointer"
              onClick={() => toggleFAQ(index)}
            >
              <div className="flex justify-between items-center">
                <h3
                  className={`text-[0.75rem] md:text-[1.25rem] leading-normal text-[#1D1D1D] font-[Figtree] tracking-tight 
                                ${
                                  openIndex === index
                                    ? "font-bold"
                                    : "font-medium"
                                }`}
                >
                  {faq.question}
                </h3>
                <span className="text-xl font-bold">
                  {openIndex === index ? (
                    <img
                      src="/assets/UpArrow.png"
                      alt="Collapse"
                      className="w-[0.8125rem] h-[0.5125rem]"
                    />
                  ) : (
                    <img
                      src="/assets/DownArrow.png"
                      alt="Expand"
                      className="w-[0.8125rem] h-[0.5125rem]"
                    />
                  )}
                </span>
              </div>
              {openIndex === index && (
                <p className="text-[#2F2A35] text-[0.625rem] md:text-[0.875rem] font-normal mt-2 leading-[1.34413rem] md:leading-[1.6875rem]">
                  {faq.answer}
                </p>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
